import React from "react";

import { ContentModuleBaseAttributes } from "utils/orm";
import styles from "./articleContainer.module.scss";

export interface HtmlBlock extends ContentModuleBaseAttributes {
    html: string;
}

export const HtmlModule: React.FC<HtmlBlock> = (props) => {
    const { html } = props;
    // eslint-disable-next-line react/no-danger
    return <div className={styles.contentModule} dangerouslySetInnerHTML={{ __html: html }} />;
};
